import { Injectable, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, DocumentReference, AngularFirestoreDocument } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { ILocation } from '.././interface/location.interface';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  private locations: Observable<ILocation[]>;
  private locationCollection: AngularFirestoreCollection<ILocation>;
  private locationDocument: AngularFirestoreDocument<ILocation>;

  constructor(private fireAuth: AngularFireAuth, private fireStore: AngularFirestore) {
    this.locationCollection = this.fireStore.collection('esalCorp.Location');
    // this.locations = this.locationCollection.snapshotChanges().pipe( // sem o pipe iriamos obter somente os dados mas não o id,
    //   map(actions => {                                       // essa parte foi tirada da documentação do angularfire
    //     return actions.map(a => {
    //       const data = a.payload.doc.data();
    //       const id = a.payload.doc.id;
    //       return { id, ...data };
    //     })
    //   })
    // )
  }

  addLocation(location: ILocation): any {
    return this.locationCollection.add(location);
  }

  signIn(userEmail: string) {
    return this.fireAuth.signInWithEmailAndPassword(userEmail, 'g7f8a9d8f65sab78cx5421b').then((res) => {
    }, error => {
      // Caso o usuário não seja encontrado cadastra um novo
      if ((<any>error).code === 'auth/user-not-found') {
        this.fireAuth.createUserWithEmailAndPassword(userEmail, 'g7f8a9d8f65sab78cx5421b').then(() => {
          window.location.reload();
        });
      }
    });
  }

  signOut() {
    this.fireAuth.signOut();
  }


}
